<div class="product-management">
  <!-- Header Section -->
  <div class="row mb-4">
    <div class="col-md-6">
      <h4>Product Management</h4>
      <p class="text-muted">Manage your store's product catalog</p>
    </div>
    <div class="col-md-6 text-end">
      <button class="btn btn-outline-success btn-sm me-2" (click)="exportProductsCSV()" title="Download all products as CSV">
        <i class="fas fa-download"></i> Export CSV
      </button>
      <ng-container *ngIf="breeceEnabled">
        <button class="btn btn-outline-secondary btn-sm me-2" type="button"
          [disabled]="breeceBulkSyncing"
          (click)="syncAllToBreece()">
          <nb-icon icon="sync-outline"></nb-icon>
          {{ breeceBulkSyncing ? 'Syncing...' : 'Sync All' }}
        </button>
        <button class="btn btn-outline-info btn-sm me-2" type="button"
          [disabled]="breeceBulkSyncing || selectedProducts.size === 0"
          (click)="syncSelectedToBreece()"
          [nbTooltip]="selectedProducts.size === 0 ? 'Select products first' : 'Sync ' + selectedProducts.size + ' selected'">
          <nb-icon icon="pricetags-outline"></nb-icon>
          {{ breeceBulkSyncing ? 'Syncing...' : 'Sync Selected (' + selectedProducts.size + ')' }}
        </button>
        <button class="btn btn-outline-success btn-sm me-2" type="button"
          [disabled]="breeceBulkSyncing || selectedProducts.size === 0"
          (click)="createSelectedInBreece()"
          [nbTooltip]="selectedProducts.size === 0 ? 'Select products first' : 'Create ' + selectedProducts.size + ' in Breece'">
          <nb-icon icon="upload-outline"></nb-icon>
          {{ breeceBulkSyncing ? 'Creating...' : 'Create Selected (' + selectedProducts.size + ')' }}
        </button>
      </ng-container>
      <button class="btn btn-primary" (click)="openAddProductDialog()">
        <nb-icon icon="plus-outline"></nb-icon>
        Add Product
      </button>
    </div>
  </div>

  <!-- Search and Filters -->
  <nb-card class="mb-4">
    <nb-card-body>
      <div class="row align-items-center">
        <!-- Search -->
        <div class="col-md-4">
          <div class="input-group">
            <input 
              type="text" 
              class="form-control" 
              placeholder="Search products..." 
              [(ngModel)]="searchQuery"
              (keyup.enter)="onSearch()">
            <button class="btn btn-outline-secondary" type="button" (click)="onSearch()">
              <nb-icon icon="search-outline"></nb-icon>
            </button>
          </div>
        </div>

        <!-- Sort -->
        <div class="col-md-3">
          <select class="form-select" [(ngModel)]="sortBy" (change)="onSortChange()">
            <option value="createdAt">Date Created</option>
            <option value="name">Name</option>
            <option value="price">Price</option>
            <option value="salesCount">Sales</option>
          </select>
        </div>

        <div class="col-md-2">
          <select class="form-select" [(ngModel)]="sortOrder" (change)="onSortChange()">
            <option value="desc">Descending</option>
            <option value="asc">Ascending</option>
          </select>
        </div>

        <!-- Filter Toggle -->
        <div class="col-md-3 text-end">
          <button class="btn btn-outline-secondary me-2" (click)="toggleFilters()">
            <nb-icon icon="options-outline"></nb-icon>
            Filters
          </button>
          <button class="btn btn-outline-secondary" (click)="loadProducts()">
            <nb-icon icon="refresh-outline"></nb-icon>
          </button>
        </div>
      </div>

      <!-- Advanced Filters -->
      <div *ngIf="showFilters" class="row mt-3 pt-3 border-top">
        <div class="col-md-3">
          <label class="form-label">Category</label>
          <select class="form-select" [(ngModel)]="selectedCategory" (change)="onFilterChange()">
            <option value="">All Categories</option>
            <option *ngFor="let category of categories" [value]="category._id">
              {{ category.name }}
            </option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label class="form-label">Stock Status</label>
          <select class="form-select" [(ngModel)]="selectedStatus" (change)="onFilterChange()">
            <option value="">All Status</option>
            <option value="instock">In Stock</option>
            <option value="lowstock">Low Stock</option>
            <option value="outofstock">Out of Stock</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label">Min Price</label>
          <input 
            type="number" 
            class="form-control" 
            [(ngModel)]="minPrice"
            (change)="onFilterChange()"
            placeholder="0">
        </div>

        <div class="col-md-2">
          <label class="form-label">Max Price</label>
          <input 
            type="number" 
            class="form-control" 
            [(ngModel)]="maxPrice"
            (change)="onFilterChange()"
            placeholder="∞">
        </div>

        <div class="col-md-2">
          <label class="form-label">Aisle</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="placementAisle"
            (keyup.enter)="onFilterChange()"
            placeholder="e.g. A3">
        </div>

        <div class="col-md-2">
          <label class="form-label">Shelf</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="placementShelf"
            (keyup.enter)="onFilterChange()"
            placeholder="e.g. S2">
        </div>

        <div class="col-md-2 d-flex align-items-end">
          <button class="btn btn-outline-secondary w-100" (click)="clearFilters()">
            Clear Filters
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Bulk Actions -->
  <div *ngIf="selectedProducts.size > 0" class="bulk-actions mb-3">
    <nb-card>
      <nb-card-body class="py-2">
        <div class="row align-items-center">
          <div class="col-md-6">
            <span class="me-3">{{ selectedProducts.size }} products selected</span>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-8">
                <select class="form-select" [(ngModel)]="bulkAction">
                  <option value="">Select Action</option>
                  <option value="enable">Enable</option>
                  <option value="disable">Disable</option>
                  <option value="delete">Delete</option>
                </select>
              </div>
              <div class="col-md-4">
                <button class="btn btn-primary w-100" (click)="executeBulkAction()">
                  Execute
                </button>
              </div>
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>

  <!-- Products Table -->
  <nb-card>
    <nb-card-body class="p-0">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th style="width: 40px;">
                <nb-checkbox 
                  [checked]="selectedProducts.size === products.length && products.length > 0"
                  [indeterminate]="selectedProducts.size > 0 && selectedProducts.size < products.length"
                  (checkedChange)="selectAllProducts()">
                </nb-checkbox>
              </th>
              <th style="width: 80px;">Image</th>
              <th>Product</th>
              <th>Category</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Active</th>
              <th>Visible</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of products; trackBy: trackByProductId">
              <td>
                <nb-checkbox 
                  [checked]="selectedProducts.has(product._id)"
                  (checkedChange)="toggleProductSelection(product._id)">
                </nb-checkbox>
              </td>
              
              <td>
                <div class="product-image">
                  <img 
                    *ngIf="getProductImageUrl(product)" 
                    [src]="getProductImageUrl(product)" 
                    [alt]="product.name"
                    class="img-thumbnail"
                    (error)="onImageError($event)">
                  <div *ngIf="!getProductImageUrl(product)" class="placeholder-image">
                    <nb-icon icon="image-outline"></nb-icon>
                  </div>
                </div>
              </td>
              
              <td>
                <div class="product-info">
                  <strong>{{ product.name }}</strong>
                  <span *ngIf="product.isVisible === false" class="badge bg-secondary ms-1" style="font-size:0.7rem;">Hidden</span>
                  <br>
                  <small *ngIf="skuRequirementEnabled && product.sku" class="text-muted">SKU: {{ product.sku }}</small>
                  <small *ngIf="product.plu" class="text-muted" [class.ms-2]="skuRequirementEnabled && product.sku">PLU: {{ product.plu }}</small>
                  <div class="mt-1">
                    <nb-badge *ngIf="product.soldByWeight" status="success" text="⚖️ By Weight" class="me-1"></nb-badge>
                    <nb-badge *ngIf="product.isFeatured" status="warning" text="Featured" class="me-1"></nb-badge>
                    <nb-badge *ngIf="product.ageRestricted" status="danger" class="me-1">
                      <span class="me-1">🔞</span>{{ product.minimumAge }}+
                    </nb-badge>
                    <nb-badge *ngIf="product.hasDeposit && product.depositCategory" status="info" class="me-1">
                      <span class="me-1">🍾</span>{{ getDepositDisplayText(product) }}
                    </nb-badge>
                    <nb-badge *ngIf="product.hasConsumptionLimit && product.consumptionLimit" status="primary" class="me-1">
                      <span class="me-1">🛒</span>Limited: {{ getConsumptionLimitDisplay(product) }}
                    </nb-badge>
                    <nb-badge *ngIf="product.globalProductId"
                      [text]="getLockedFieldsCount(product) > 0 ? 'Overrides' : 'Global'"
                      [status]="getLockedFieldsCount(product) > 0 ? 'warning' : 'success'"
                      [nbTooltip]="getLockedFieldsCount(product) > 0
                        ? 'Linked to Global Catalog — ' + getLockedFieldsCount(product) + ' field(s) overriding global values'
                        : 'Synced with Global Catalog'">
                    </nb-badge>
                  </div>
                </div>
              </td>
              
              <td>
                <span class="category-name">{{ getCategoryName(product.categoryId) }}</span>
              </td>
              
              <td>
                <div class="price-info">
                  <strong>{{ formatCurrency(product.price) }}</strong>
                  <div *ngIf="product.originalPrice && product.originalPrice !== product.price" class="original-price">
                    <small class="text-muted text-decoration-line-through">
                      {{ formatCurrency(product.originalPrice) }}
                    </small>
                  </div>
                </div>
              </td>
              
              <td>
                <div class="stock-info">
                  <span class="stock-quantity">{{ product.inventory?.quantity || 0 }}</span>
                  <br>
                  <nb-badge 
                    [status]="getStockStatusColor(product.stockStatus)"
                    [text]="product.stockStatus | titlecase">
                  </nb-badge>
                </div>
              </td>
              
              <td>
                <nb-toggle
                  [checked]="product.status === 1"
                  (checkedChange)="toggleProductStatus(product, $event)"
                  status="success">
                </nb-toggle>
              </td>

              <td>
                <nb-toggle
                  [checked]="product.isVisible"
                  (checkedChange)="toggleProductVisibility(product, $event)"
                  status="info">
                </nb-toggle>
              </td>
              
              <td>
                <div class="action-buttons">
                  <button 
                    class="btn btn-sm btn-outline-primary me-1" 
                    (click)="editProduct(product)"
                    nbTooltip="Edit Product">
                    <nb-icon icon="edit-outline"></nb-icon>
                  </button>
                  
                  <button 
                    class="btn btn-sm btn-outline-warning me-1" 
                    (click)="toggleProductFeatured(product)"
                    nbTooltip="Toggle Featured">
                    <nb-icon [icon]="product.isFeatured ? 'star' : 'star-outline'"></nb-icon>
                  </button>
                  
                  <button 
                    class="btn btn-sm btn-outline-danger" 
                    (click)="deleteProduct(product._id)"
                    nbTooltip="Delete Product">
                    <nb-icon icon="trash-outline"></nb-icon>
                  </button>

                  <button *ngIf="breeceEnabled"
                    class="btn btn-sm btn-outline-info ms-1"
                    type="button"
                    [nbTooltip]="'Sync to Breece'"
                    [disabled]="syncingProductIds.has(product._id)"
                    (click)="syncProductToBreece(product._id)">
                    <nb-icon [icon]="syncingProductIds.has(product._id) ? 'loader-outline' : 'monitor-outline'"></nb-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && products.length === 0" class="text-center py-5">
        <nb-icon icon="cube-outline" class="large-icon text-muted mb-3"></nb-icon>
        <h5>No Products Found</h5>
        <p class="text-muted">Start by adding your first product to the catalog.</p>
        <button class="btn btn-primary" (click)="openAddProductDialog()">
          <nb-icon icon="plus-outline"></nb-icon>
          Add Your First Product
        </button>
      </div>

      <!-- Loading State -->
      <div *ngIf="loading" class="text-center py-5">
        <nb-spinner size="large"></nb-spinner>
        <p class="mt-3 text-muted">Loading products...</p>
      </div>
    </nb-card-body>

    <!-- Pagination -->
    <nb-card-footer *ngIf="totalPages > 1">
      <div class="d-flex justify-content-between align-items-center">
        <div class="pagination-info">
          Showing {{ (currentPage - 1) * pageSize + 1 }} to 
          {{ Math.min(currentPage * pageSize, totalProducts) }} of 
          {{ totalProducts }} products
        </div>
        
        <nav aria-label="Product pagination">
          <!-- Manual Bootstrap Pagination -->
          <ul class="pagination justify-content-center">
            <!-- Previous Button -->
            <li class="page-item" [class.disabled]="currentPage <= 1">
              <button 
                class="page-link" 
                (click)="onPageChange(currentPage - 1)"
                [disabled]="currentPage <= 1">
                Previous
              </button>
            </li>
            
            <!-- First Page -->
            <li class="page-item" [class.active]="currentPage === 1" *ngIf="totalPages > 1">
              <button class="page-link" (click)="onPageChange(1)">1</button>
            </li>
            
            <!-- Left Ellipsis -->
            <li class="page-item disabled" *ngIf="currentPage > 4">
              <span class="page-link">...</span>
            </li>
            
            <!-- Pages around current -->
            <li 
              class="page-item" 
              [class.active]="currentPage === page"
              *ngFor="let page of getPaginationPages()" 
              [attr.aria-current]="currentPage === page ? 'page' : null">
              <button class="page-link" (click)="onPageChange(page)">{{ page }}</button>
            </li>
            
            <!-- Right Ellipsis -->
            <li class="page-item disabled" *ngIf="currentPage < totalPages - 3">
              <span class="page-link">...</span>
            </li>
            
            <!-- Last Page -->
            <li class="page-item" [class.active]="currentPage === totalPages" *ngIf="totalPages > 1 && currentPage !== totalPages">
              <button class="page-link" (click)="onPageChange(totalPages)">{{ totalPages }}</button>
            </li>
            
            <!-- Next Button -->
            <li class="page-item" [class.disabled]="currentPage >= totalPages">
              <button 
                class="page-link" 
                (click)="onPageChange(currentPage + 1)"
                [disabled]="currentPage >= totalPages">
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </nb-card-footer>
  </nb-card>

</div>